<h2 mat-dialog-title class="md-0">
  Import companies for:
  {{ selectedProduct?.name || productLabel || '—' }}
</h2>

<div class="import-product__overlay" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" class="import-product__progress-bar"></mat-progress-bar>
  <span>Loading data...</span>
</div>

<div mat-dialog-content class="import-product">
  <div
    class="import-product__summary"
    *ngIf="!loading && rows.length"
  >
    Will add {{ selectedCompanyCount }}
    {{ selectedCompanyCount === 1 ? 'company' : 'companies' }} using
    {{ selectedProduct?.name || productLabel || 'this product' }}
    to BuyerCaddy. {{ missingCompanyCount }}
    {{ missingCompanyCount === 1 ? 'company will be' : 'companies will be' }} skipped
    as they do not exist in BuyerCaddy yet.
  </div>

  <div
    class="import-product__product-alert"
    *ngIf="selectedProducts.length > 1 && !selectedProduct"
  >
    <div class="import-product__product-alert-text">
      Multiple products found. Please choose the correct one to continue.
    </div>
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="openProductSelectDialog()"
      [disabled]="!productsVendorDomain"
    >
      Choose product
    </button>
  </div>

  <div
    class="import-product__product-alert import-product__product-alert--selected"
    *ngIf="selectedProducts.length > 1 && selectedProduct"
  >
    <div class="import-product__product-alert-text">
      Selected product: <span>{{ selectedProduct?.name }}</span>
    </div>
    <button
      mat-button
      type="button"
      (click)="openProductSelectDialog()"
      [disabled]="!productsVendorDomain"
    >
      Change
    </button>
  </div>

  <ng-container *ngIf="rows.length; else emptyState">
    <div class="import-product__table-wrapper">
      <table mat-table [dataSource]="rows" class="import-product__table">
        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef class="import-product__select-column">
          </th>
          <td mat-cell *matCellDef="let row" class="import-product__select-column">
            <mat-checkbox
              color="primary"
              [disabled]="!row.selectedCompany"
              [checked]="row.isSelected"
              (change)="toggleRowSelection(row, $event.checked)"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="CompanyName">
          <th mat-header-cell *matHeaderCellDef>Company Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.CompanyName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Country">
          <th mat-header-cell *matHeaderCellDef>Country</th>
          <td mat-cell *matCellDef="let row">
            {{ row.Country }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Industry">
          <th mat-header-cell *matHeaderCellDef>Industry</th>
          <td mat-cell *matCellDef="let row">
            {{ row.Industry }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Probability">
          <th mat-header-cell *matHeaderCellDef>Probability</th>
          <td mat-cell *matCellDef="let row">
            {{ row.Probability }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Source">
          <th mat-header-cell *matHeaderCellDef>Source</th>
          <td mat-cell *matCellDef="let row">
            {{ row.Source }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateFirstVerified">
          <th mat-header-cell *matHeaderCellDef>First Verified</th>
          <td mat-cell *matCellDef="let row">
            {{ row.dateFirstVerified | date: 'mediumDate' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateLastVerified">
          <th mat-header-cell *matHeaderCellDef>Last Verified</th>
          <td mat-cell *matCellDef="let row">
            {{ row.dateLastVerified | date: 'mediumDate' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <div class="import-product__empty">
      <p>No companies found for this product yet.</p>
    </div>
  </ng-template>
</div>

<mat-dialog-actions align="end" class="import-product__actions">
  <button mat-flat-button  type="button" (click)="onClose()">
    Close
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="importSelected()"
    [disabled]="!canImport"
  >
    <span *ngIf="!importing">Import</span>
    <span *ngIf="importing">Importing...</span>
  </button>
  
</mat-dialog-actions>
